/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_By_HrInputs */

const en_ui_color_by_hr = /** @type {(inputs: Ui_Color_By_HrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heart rate`)
};

const de_ui_color_by_hr = /** @type {(inputs: Ui_Color_By_HrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herzfrequenz`)
};

/**
* | output |
* | --- |
* | "Heart rate" |
*
* @param {Ui_Color_By_HrInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_hr = /** @type {((inputs?: Ui_Color_By_HrInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_HrInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_hr(inputs)
	return de_ui_color_by_hr(inputs)
});